//-----------------------------------------------------
// -- 高さあわせ
//-----------------------------------------------------
export function height_align(){
	var windowwidth = $(window).width();

	if ($('.-solution')) {
		block = $('.-solution').find('[class^=block__pic]');
		block.find('.pic_box').removeAttr('style');
		block.find('.elem__paragraph').removeAttr('style');
		if (windowwidth <= 898) {
			block.each(function(e) {
				var _this = $(this);
				$(this).find('.pic_box').css('top', _this.find('[class^="elem__heading"]').height() + 60);
				$(this).find('.elem__paragraph').css('margin-top', _this.find('.pic_box').height() + 30);
			});
		}
	}


	if ($('[class^="block__divide"]').hasClass('--feature')) {
		var array = [],
			heding_array = [],
			pic_array = [],
			text_array = [],
			block = $('[class^="block__divide"].--feature');

		if (windowwidth > 736) {
			block.find('[class^="elem__heading"]').each(function(e) {
				heding_array.push($(this).innerHeight());
			});
			block.find('[class^="block__pic"]').each(function(e) {
				array.push($(this).innerHeight());
				text_array.push($(this).find('[class^="elem__paragraph"]').innerHeight());
				pic_array.push($(this).find('img').innerHeight());

			});
			// block.find('[class^="block__pic"]').innerHeight(Math.max.apply(null, array));
			block.find('[class^="elem__heading"]').innerHeight(Math.max.apply(null, heding_array));
			block.find('[class^="elem__paragraph"]').innerHeight(Math.max.apply(null, text_array));
			block.find('img').innerHeight(Math.max.apply(null, pic_array));
		} else {
			// block.find('[class^="block__pic"]').innerHeight('');
			block.find('[class^="elem__heading"]').innerHeight('');
			block.find('[class^="elem__paragraph"]').innerHeight('');
			block.find('img').innerHeight('');
		}
	}

	if ($('[class^="section__content"]').hasClass('-worries')) {
		var array = [],
			block = $('.-worries').find('[class^="block__divide"]');

		if (windowwidth > 736) {
			block.find('.divide_box').each(function(e) {
				array.push($(this).innerHeight());
			});
			block.find('.divide_box > div').innerHeight(Math.max.apply(null, array));
		} else {
			block.find('.divide_box > div').innerHeight('');
		}
	}
	if ($('.block__step')) {
		var array = [],
			block = $('.block__step');

			if (windowwidth > 736) {
				block.find('li').each(function(e) {
					array.push($(this).innerHeight());
				});
				block.find('li').innerHeight(Math.max.apply(null, array));
			} else {
				block.find('li').innerHeight('');
			}
	}
}